import {InputField} from '@/pages/components/common/InputField';

type Props = {
    value: string;
    onChange: (next: string) => void;
    fullWidth?: boolean;
    display?: boolean;
    error?: boolean;
    helperText?: string;
    size?: 'small' | 'medium';
};

/** Same rules as CompanyDetail BR: empty OK; if any content, left part before "-" required. */
export function validateTaxRepBr(br: string): boolean {
    if (!br) return true;
    const parts = br.split('-');
    return !!(parts[0] && parts[0].trim().length > 0);
}

export function hasTaxRepBrContent(br: string): boolean {
    return !!(br && br.trim().length > 0);
}

/**
 * Business Registration No. � same render as CompanyDetail (`InputField` br-suffix).
 */
export function TaxRepBrField({
                                  value,
                                  onChange,
                                  fullWidth = true,
                                  display = false,
                                  error,
                                  helperText,
                                  size = 'small',
                              }: Props) {
    const brError = error ?? (hasTaxRepBrContent(value) && !validateTaxRepBr(value));
    const brHelper = helperText ?? (brError ? 'BR prefix is required' : '');

    return (
        <InputField
            type="br-suffix"
            size={size}
            align="left"
            label="Business Registration No."
            name="BR"
            value={value || ''}
            fullWidth={fullWidth}
            display={display}
            separator="-"
            rightPartDefault="000"
            leftPartMaxLength={8}
            error={brError}
            helperText={brHelper}
            onChange={(e) => {
                if (display) return;
                onChange((e.target as HTMLInputElement).value);
            }}
        />
    );
}
